import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import closeButton from '../../assets/close-button.svg';

const Modal = (props) => {
  const { title, children, isModalOpen, className, onClose } = props;
  if (!isModalOpen) return null;

  return (
    <div className={cn('modal-container', className)}>
      <div className="modal">
        <div className="form-header">
          <h2>{title}</h2>
          <button className="action-button top" onClick={onClose}>
            <img className="close-icon" alt="close-button" src={closeButton} />
          </button>
        </div>
        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

Modal.defaultProps = {
  className: '',
};

export default Modal;
